export const pixelTrackEvent = (text = "") => {
  if (fbq) {
    fbq("track", text)
  }
}
